import { render, staticRenderFns } from "./ContainerNewsDetail.vue?vue&type=template&id=27785ca1"
import script from "./ContainerNewsDetail.vue?vue&type=script&lang=js"
export * from "./ContainerNewsDetail.vue?vue&type=script&lang=js"
import style0 from "./ContainerNewsDetail.vue?vue&type=style&index=0&id=27785ca1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports